import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'ib-spinner',
  templateUrl: './spinner.component.html',
})
export class IbSpinnerComponent {
  @Input() fluid: boolean;
  @Input() diameter?: number;
  @Input() isInsideBtn?: boolean;

  @HostBinding('class') get classes(): string {
    return [
      this.fluid ? 'ib-spinner--fluid' : '',
      this.isInsideBtn ? 'ib-spinner--inside-btn' : '',
    ].join(' ');
  }
}
